import React from 'react';
import { motion } from 'framer-motion';
import { Lock } from 'lucide-react';
export function FinalCTA() {
  return <section id="final-cta" className="py-24 bg-brand-orange relative overflow-hidden" data-id="element-44">
      <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/carbon-fibre.png')] opacity-10 mix-blend-overlay" data-id="element-45" />

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-46">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-47">
          <h2 className="text-4xl md:text-6xl uppercase text-white mb-4 drop-shadow-lg" data-id="element-48">
            ACCESO INMEDIATO
          </h2>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-6" data-id="element-49">
            <span className="text-2xl md:text-3xl text-white/70 line-through font-display" data-id="element-50">
              $17 USD
            </span>
            <div className="bg-zinc-950 text-white px-6 py-3 rounded-xl shadow-2xl border-2 border-white/20" data-id="element-51">
              <span className="text-xs md:text-sm uppercase tracking-widest text-brand-orange font-bold block" data-id="element-52">
                HOY POR SOLO
              </span>
              <span className="text-4xl md:text-5xl font-display" data-id="element-53">
                $6,39 USD
              </span>
            </div>
          </div>

          <div className="inline-block bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-5 py-2 mb-8" data-id="element-54">
            <span className="text-white font-bold text-sm md:text-base uppercase tracking-wider" data-id="element-55">
              🔥 Descuento por tiempo limitado
            </span>
          </div>

          <p className="text-xl md:text-2xl text-white/90 mb-10 max-w-2xl mx-auto font-medium" data-id="element-56">
            Obtén "El Manual del Gym en el Living" y empieza hoy mismo tu
            transformación. Sin excusas, sin cuotas mensuales, sin traslados.
          </p>

          <a href="https://nuevoeje.com/cart/55162529448227:1" target="_blank" rel="noopener noreferrer" className="inline-block bg-zinc-950 hover:bg-black text-white font-display text-xl md:text-2xl uppercase tracking-wider py-5 px-10 rounded-xl shadow-2xl transition-transform duration-300 hover:scale-105 w-full md:w-auto mb-6" data-id="element-57">
            ¡SÍ, QUIERO EMPEZAR MI ENTRENAMIENTO AHORA!
          </a>

          <div className="flex items-center justify-center gap-2 text-white/80 text-sm md:text-base font-medium" data-id="element-58">
            <Lock className="w-4 h-4" data-id="element-59" />
            <span data-id="element-60">
              Recibirás el acceso directo a tu PDF tras el pago seguro.
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}